import axios from 'axios';
import Jsona from 'jsona';
import qs from 'qs';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get(params) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/abordaje/buscarSubcorridas?subcorridas_ids=${params.subcorridas_ids}&token=${params.token}`, options)
    .then(response => {
      let boarding = jsona.deserialize(response.data);
      delete boarding.links;
      return boarding;
    });
}

function getlistado() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/abordaje/listadoSubcorridas`, options)
    .then(response => {
      let boarding = jsona.deserialize(response.data);
      delete boarding.links;
      return boarding;
    });
}

function getlistadoFdt() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/abordaje/listadoSubcorridasFueraDeTiempo`, options)
    .then(response => {
      let boarding = jsona.deserialize(response.data);
      delete boarding.links;
      return boarding;
    });
}

function searchTicket(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/abordaje/buscarBoleto`, options)
    .then(response => {
      return response.data;
    });
}

function confirmDeparture(boarding) {
  const payload = jsona.serialize({
    stuff: boarding,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/abordaje/confirmarSalida`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function confirmBoarding(boarding) {
  const payload = jsona.serialize({
    stuff: boarding,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/abordaje/confirmarAbordaje`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function canjeBlanco(boarding) {
  const payload = jsona.serialize({
    stuff: boarding,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/abordaje/canjearBlanco`, payload, options)
    .then(response => {
      return response.data;
    });
}

function confirmBoardingBaggage(boarding) {
  const payload = jsona.serialize({
    stuff: boarding,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/abordaje/confirmarAbordajeEquipaje`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

export default {
  get,
  searchTicket,
  confirmDeparture,
  confirmBoarding,
  canjeBlanco,
  getlistado,
  confirmBoardingBaggage,
  getlistadoFdt
};

